import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Caption from './Caption';
import HomeModal from './HomeModal';
import { breakpoints } from './../../styles/theme.json';
import { instagramFormat, returnOpacity } from './../../scripts';
class LinkWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popover: false,
      popoverImage: {},
      loading: false
    };
    this.gradientOpacity = {
      opacity: returnOpacity(this.props.linkData.slideshow_gradient_opacity)
    };
  }
  _expandLink(item) {
    this.setState({
      popover: true,
      popoverImage: item
    });
  }
  _closePopup() {
    this.setState({
      popover: false
    });
  }
  _clickLink(linkData, props) {
    if (linkData == 'external') {
      window.open(props.link, '_blank');
    } else if (linkData == 'instagram') {
      instagramFormat.instaLink(props.description);
    } else if (linkData == 'expand') {
      this._expandLink(props);
    }
  }
  render() {
    return (
      <Fragment>
        {(this.props.linkClass) && <div className='block-out'/>}
        {(this.state.popover) && <HomeModal popoverData={this.props.linkData} ClickFunction={() => this._closePopup()}/>}
        {(this.props.window_width >= breakpoints.desktop) &&
          <div className={(!this.props.hideCaption) ? `hp-image-caption-wrap ${this.props.video_header_state}` : 'hp-image-caption-wrap'}>
            <Caption linkData={this.props.linkData} type={this.props.linkData.type} opacity={this.props.linkData.slideshow_gradient_opacity}/>
          </div>
        }
        {(this.props.linkData.type !== 'border') &&
          <div className={'hp-image-gradient-wrapper'}>
            <div style={this.gradientOpacity} className='hp-image-gradient'/>
          </div>
        }
        {(this.props.linkData.linkType == 'internal' && this.props.linkData.link.slug)
          ? <Link className='grid-link' to={'/' + this.props.linkData.link.postType + '/' + this.props.linkData.link.slug}>
              {this.props.children}
            </Link>
          : <a className='grid-link' onClick={() => this._clickLink(this.props.linkData.linkType, this.props.linkData)}>
              {this.props.children}
            </a>
        }
      </Fragment>
    );
  }
}

export default connect(
  state => ({
    video_header_state: state.video_state.header_style,
    window_width: state.window_dimensions.window_width
  })
)(LinkWrapper);




// WEBPACK FOOTER //
// ./src/pages/home/LinkWrapper.js